/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Select_Team_Members_LabelInputs */

const en_team_share_select_team_members_label = /** @type {(inputs: Team_Share_Select_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select team members`)
};

const fr_team_share_select_team_members_label = /** @type {(inputs: Team_Share_Select_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner les membres de l’équipe`)
};

const de_team_share_select_team_members_label = /** @type {(inputs: Team_Share_Select_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teammitglieder auswählen`)
};

const it_team_share_select_team_members_label = /** @type {(inputs: Team_Share_Select_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona i membri del team`)
};

const ru_team_share_select_team_members_label = /** @type {(inputs: Team_Share_Select_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите членов команды`)
};

const es_team_share_select_team_members_label = /** @type {(inputs: Team_Share_Select_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar miembros del equipo`)
};

const zh_cn2_team_share_select_team_members_label = /** @type {(inputs: Team_Share_Select_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择团队成员`)
};

const ja_team_share_select_team_members_label = /** @type {(inputs: Team_Share_Select_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームメンバーを選択`)
};

const hi_team_share_select_team_members_label = /** @type {(inputs: Team_Share_Select_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम के सदस्यों का चयन करें`)
};

const pt_pt2_team_share_select_team_members_label = /** @type {(inputs: Team_Share_Select_Team_Members_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione os membros da equipe`)
};

/**
* | output |
* | --- |
* | "Select team members" |
*
* @param {Team_Share_Select_Team_Members_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_select_team_members_label = /** @type {((inputs?: Team_Share_Select_Team_Members_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Select_Team_Members_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_select_team_members_label(inputs)
	if (locale === "de") return de_team_share_select_team_members_label(inputs)
	if (locale === "it") return it_team_share_select_team_members_label(inputs)
	if (locale === "ru") return ru_team_share_select_team_members_label(inputs)
	if (locale === "es") return es_team_share_select_team_members_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_select_team_members_label(inputs)
	if (locale === "ja") return ja_team_share_select_team_members_label(inputs)
	if (locale === "hi") return hi_team_share_select_team_members_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_select_team_members_label(inputs)
	return en_team_share_select_team_members_label(inputs)
});